module.exports = __webpack_public_path__ + "img/icon5.1b600511.png";